import React from 'react';

const UpdateChecker = () => {
    return <></>;
};

export default UpdateChecker;